<template>
  <div
    id="cta"
    v-wave="showVWave"
    class="flex w-full rounded-xl font-medium text-black justify-center items-center p-3 bg"
    :style="{
      background: outlined ? 'white' :colors.leadColor,
      border: outlined ? `1px solid ${colors.darkenColor}` : 'none',
      color: outlined ? colors.darkenColor: colors.fontColor,
    }"
    @click="clickCta">
    <div id="button-label" class="w-full flex justify-center h-6 items-center">
      <span v-if="!loading">{{ label }}</span>
      <hollow-dots-spinner
        v-if="loading"
        :animationDuration="750"
        :dotSize="12"
        :dotsNum="3"
        color="white"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HollowDotsSpinner } from 'epic-spinners';
import { PropType } from 'vue';

const props = defineProps({
  disable: {
    type: Boolean,
    default: false,
    required: false
  },
  label: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false,
    required: false
  },
  outlined: {
    type: Boolean,
    default: false,
    required: false
  },
  colors: {
    type: Object as PropType<{
      leadColor: string;
      fontColor: string;
      darkenColor: string;
    }>,
    required: false,
    default: () => ({
      leadColor: '#000000',
      fontColor: '#000000',
      darkenColor: '#000000',
    })
  }
});
const emit = defineEmits(['click']);

const showVWave = !props.disable;

const clickCta = () => {
  if (!props.disable)
    emit('click');
};

</script>
